import React, { Component, useState, useEffect } from "react";
import { FormControl, InputGroup, Tab, Tabs, Button, Container, ListGroup, Row, Col, Image} from "react-bootstrap";
import "./friends.scss";
import User from "../../common/user/user";
import ApiV2 from "../../common/apiV2";
import defaultPhoto from "../../images/default.png";
import PropTypes from "prop-types";
import { Link, withRouter } from 'react-router-dom';

function Friends(props) {
    // const [users, setUsers] = useState([])
    const [search, setSearch] = useState("")
    const [follower, setFollower] = useState({})
    const [following, setFollowing] = useState({})
    const [requests, setRequests] = useState({})
    const [inProfile, setInProfile] = useState(false);
    const [flag, setFlag] = useState(false)

    useEffect(() => {
        // How you get the param id from route
        console.log("PATH: ", JSON.stringify(props.match.path));
        if(props.match.path.includes("/profile/")){
            setInProfile(true);
        }
        try {
            console.log("Fetching users following and your followers")
            fetchFollowing(props.match.params.id);
            fetchFollowers(props.match.params.id);
            fetchRequests(props.match.params.id);
        } catch (error) {
            console.log("Unable to retrieve friends");
        }
            setFlag(false);
        }
        ,[flag]
    );

    //function to search users using the backend api call
    const fetchFollowing = async (userId) => {
        const response = await ApiV2.getFollowing(userId)
        setFollowing(response.sort((a,b) => a.firstName.localeCompare(b.firstName)));
    }

    //function to search users using the backend api call
    const fetchFollowers = async (userId) => {
        const response = await ApiV2.getFollower(userId)
        setFollower(response.sort((a,b) => a.firstName.localeCompare(b.firstName)));
    }

    //function to search user requests using the backend api call
    const fetchRequests = async (userId) => {
        const response = await ApiV2.getFollowerRequests(userId)
        setRequests(response.sort((a,b) => a.firstName.localeCompare(b.firstName)));
    }

    const followUser = async (userId) => {
        try {
            const response = await ApiV2.followUser(userId);
            props.notifyInfo("Followed user");
        } catch (error) {
            props.notifyFailure("Couldn't follow user: ", JSON.stringify(error));
        }
    }

    const updateFollowerRequest = async (followerUserId, approved) => {
        try {
            const response = await ApiV2.updateFollowerRequest(followerUserId, approved);
            if (approved){
                props.notifyInfo("Successfully approved follower request");
            }
            else{
                props.notifyInfo("Successfully declined follower request");
            }
            setFlag(true);
        } catch (error) {
            props.notifyFailure("Couldn't update follower request: ", JSON.stringify(error));
        }
    }

    const getProfilePhoto = (user) =>  {
        if (user.photoURL) {
            return (user.photoURL);
        } else {
            return (defaultPhoto);
        }
    }

    const renderFollowing = () => {
        if (following){
            if (Array.isArray(following)) {
                const results = following.map(user => {
                    return (
                        <User user={user}/>
                    );
                });
                return results;
            }
        }
    }

    const renderFollowers = () => {
        if (follower){
            if (Array.isArray(follower)) {
                const results = follower.map(user => {
                    return (
                        <User user={user}/>
                    );
                });
                return results;
            }
        }
    }

    const renderRequests = () => {
        if (requests){
            if (Array.isArray(requests)){
                const results = requests.map(user =>{
                    return(
                        <ListGroup.Item>
                        <Container className="p-0">
                            <Row className="text-center">
                                {/* <Col xs={2} onClick={() => props.history.push(`/user/${user.userId}`)}> */}
                                <Col xs={2}>
                                    <Image className="profile-photo" src={getProfilePhoto(user)} roundedCircle />
                                </Col>
                            {/* <Col xs={8} className="p-0" onClick={() => props.history.push(`/user/${user.userId}`)}> */}
                            <Col xs={8} className="p-0">
                                <Row className="justify-content-center">
                                    <span className="font-weight-bold friend-name">{user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1)}</span>
                                </Row>
                                <Row className="justify-content-center friend-info">
                                    <span className="font-weight-bold">264</span>&nbsp;Followers |&nbsp;<span className="font-weight-bold">233</span>&nbsp;Following</Row>
                                <Row className="justify-content-center friend-info">
                                    <span className="font-weight-bold">6</span>&nbsp;Cities |&nbsp;<span className="font-weight-bold">2</span>&nbsp;Places |&nbsp;<span className="font-weight-bold">2</span>&nbsp;Sharelist</Row>
                            </Col>
                            <Col xs={2} className="p-0 align-self-center">
                                <Row className="mb-2">
                                    <Button 
                                        variant="outline-primary"
                                        className="align-center follow-button" 
                                        size="sm"
                                        onClick={()=> updateFollowerRequest(user.userId, true)}
                                    >
                                        Accept
                                    </Button>
                                </Row>
                                <Row>
                                    <Button 
                                        variant="danger"
                                        className="align-center follow-button" 
                                        size="sm"
                                        onClick={()=> updateFollowerRequest(user.userId, false)}
                                    >
                                        Decline
                                    </Button>
                                </Row>
                            </Col>
                            </Row>
                        </Container>
                    </ListGroup.Item>
                    )
                })
                return results;
            }
        }


    }

    //render results here
    return (
        <Container fluid className="child-container p-0">
            <InputGroup className="mt-3 mb-0 px-3" >
                <FormControl
                    placeholder="Search"
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    onChange={event => {
                        setSearch(event.target.value)
                    }}
                />
                <InputGroup.Append>
                    <Button 
                    variant="outline-secondary"
                    >Clear</Button>
                </InputGroup.Append>
            </InputGroup>

            <Tabs variant="pills" className="search-tab full-width justify-content-around">
                <Tab eventKey="Following" title="Following">{renderFollowing()}</Tab>
                <Tab eventKey="Followers" title="Followers">{renderFollowers()}</Tab>
                {inProfile ? <Tab eventKey="Requests" title="Requests" >{renderRequests()}</Tab> : <></>}
            </Tabs>
        </Container>
    );
}

export default withRouter(Friends);

Friends.propTypes = {
    notifyInfo: PropTypes.func.isRequired,
    notifyFailure: PropTypes.func.isRequired
};
